import CodeMappingFormProperties from './CodeMappingFormProperties'
import CodeMappingApiUrls from 'src/apiUrls/CodeMappingApiUrls'
import { components } from 'cng-web-lib'
import React from 'react'

const {
    form: { CngViewForm }
} = components

function CodeMappingViewForm({
    showNotification,
    id,
    onFetchPreSuccess = () => {
        //do nothing
     }
}) {
    return (
        <CngViewForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            showNotification={showNotification}
            bodySection={
                <CodeMappingFormProperties.Fields
                    disabled={true}
                    showNotification={showNotification}
                />
            }
            formikProps={CodeMappingFormProperties.formikProps}
            toClientDataFormat={CodeMappingFormProperties.toClientDataFormat}
            toServerDataFormat={CodeMappingFormProperties.toServerDataFormat}
            fetch={{
                id: id,
                url: CodeMappingApiUrls.GET,
                onPreSuccess: onFetchPreSuccess
            }}
        />
    )
}

export default CodeMappingViewForm
